import React, { Component } from "react";
import { Col } from 'react-bootstrap';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import TextArea from "react-validation/build/textarea";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { withRouter} from 'react-router-dom';
import mixin from "../../../utils/mixin";
import consts from "../../../utils/constants";

import './AgentForm.scss';

import { addAgent, updateAgent, deleteAgent } from '../../../api/Api.js';
import { isEmpty, method } from "lodash";

const { methods } = mixin;

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Campo requerido
      </div>
    );
  }
};

const positiveNumber = value => {
  if (!isNaN(value) && value < 0) {
    return (
      <div className="alert alert-danger" role="alert">
        Ingresa un número válido.
      </div>
    );
  }
};

const def_user  = {
  agent_id: null,
  first_name: null,
  last_name: null,
  last_name_2: null,
  deleted: 0,
}

class AgentForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      message: null,
      loading: false,
      loading_lot: false,
      user: def_user,
      prev_agent_id: null,
      confirm_password: null,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    
    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();
    
    if (this.checkBtn.context._errors.length === 0) {
      
      let data = {...this.state.user};
      let meta = [];
      
      if(this.props.action == 'update'){
        const agent_id = this.props.agent_id;

        updateAgent({agent_id, data}).then(
          (res) => {
            if(res && res['agent_id']){
              this.props.update(res);
              this.props.close();
            }else{
              this.setState({
                loading: false,
                message: 'No se pudo actualizar el vendedor. Intenta nuevamente.'
              });
            }
          }
        );
      }else{
        data.deleted = 0;
        addAgent(data).then(
          (res) => {
            if(res && res['agent_id']){
              this.props.add(res);
              this.props.close();
            }else{
              this.setState({
                loading: false,
                message: 'No se pudo agregar el vendedor. Intenta nuevamente.'
              });
            }
          }
        );
      }

    } else {
      this.setState({
        loading: false
      });
    }
  }

  renderTitle(){
    let title = 'Agregar Vendedor';
    if(this.props.action == 'update' && this.props.user){
      title = 'Editar Vendedor';
    }
    return (<div>
              <h3>{title}</h3>
              <br/>
            </div>);
  }

  static getDerivedStateFromProps = (props, state) => {
    let l = def_user;
    
    if(props.agent_id !== state.prev_agent_id){
      
      if(props.user){
        l = {...props.user}
      }
      
      return{
        prev_agent_id: props.agent_id,
        user: {
          agent_id: l.agent_id,
          first_name: l.first_name,
          last_name: l.last_name,
          last_name_2: l.last_name_2,
          email: l.email,
          phone: l.phone,
          deleted: l.deleted,
        },
      }
    }
    return null;
  }

  getSaveBtnLabel = () => {
    return this.props.action == 'add' ? 'Agregar' : 'Guardar';
  }

  onChangeName = (e) => {
    this.setState({
        user: {...this.state.user, ...{first_name: e.target.value}}
    });
  }

  onChangeLastName = (e) => {
    this.setState({
        user: {...this.state.user, ...{last_name: e.target.value}}
    });
  }

  onChangeLastName2 = (e) => {
    this.setState({
        user: {...this.state.user, ...{last_name_2: e.target.value}}
    });
  }

  onChangeEmail = (e) => {
    this.setState({
        user: {...this.state.user, ...{email: e.target.value}}
    });
  }

  onChangePhone = (e) => {
    this.setState({
        user: {...this.state.user, ...{phone: e.target.value}}
    });
  }
  
  renderSaveBtn = () => {
    if( (this.props.action == 'add' && methods.G_canDo(consts.Security.Action.CREATE_AGENT, localStorage.getItem('user'))) ||
      (this.props.action == 'update' && methods.G_canDo(consts.Security.Action.UPDATE_AGENT, localStorage.getItem('user')))
    ){
      return (
        <button
          className="btn btn-cust-blue mr-3"
          disabled={this.state.loading}
        >
          {this.state.loading && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          <span>{this.getSaveBtnLabel()}</span>
        </button>
      )
    }
  }
  
  renderUserName = () => {
    let user = this.state.user;
    if(user) {
      let name = '';
      name += user.first_name ? user.first_name : '';
      name += user.last_name ? ' ' + user.last_name : '';
      name += user.last_name_2 ? ' ' + user.last_name_2 : '';
      return name;
    }
    return '';
  }

  delete = (e) => {
    e.preventDefault();
    const user = this.state.user;
    if(window.confirm('¿Estás seguro que deseas eliminar el vendedor ' + this.renderUserName() + '?') == true){
      let id = user['agent_id'];
      if(id){
        deleteAgent(id).then(
          (res) => {
            if(res && res['agent_id']){
              this.props.update_deleted(res['agent_id']);
            }else{
              // TODO: Mostrar mensaje
            }
          }
        );
      }
    }
  }

  renderDeleteBtn = () => {
    if(this.props.action == 'update' && methods.G_canDo(consts.Security.Action.DELETE_AGENT, localStorage.getItem('user'))){
      return (
        <button className="btn btn-cust-orange float-left delete-user" onClick={this.delete.bind(this)}>Eliminar</button>
      );
    }
  }

  render() {
    return (
      <div className="containter">
        {this.renderTitle()}
        
        <Form
          onSubmit={this.handleSubmit}
          ref={c => {
            this.form = c;
          }}
        >
          <div className="row">
            <Col sm="4" >
              <div className="form-group">
                <label htmlFor="first_name">Nombre</label>
                <Input
                  type="text"
                  className="form-control"
                  name="first_name"
                  value={this.state.user.first_name}
                  onChange={this.onChangeName}
                  validations={[required]}
                />
              </div>
            </Col>
            <Col sm="4" >
              <div className="form-group">
                <label htmlFor="last_name">Apellido Paterno</label>
                <Input
                  type="text"
                  className="form-control"
                  name="last_name"
                  value={this.state.user.last_name}
                  onChange={this.onChangeLastName}
                  validations={[required]}
                />
              </div>
            </Col>
            <Col sm="4" >
              <div className="form-group">
                <label htmlFor="last_name_2">Apellido Materno</label>
                <Input
                  type="text"
                  className="form-control"
                  name="last_name_2"
                  value={this.state.user.last_name_2}
                  onChange={this.onChangeLastName2}
                />
              </div>
            </Col>

            <Col sm="4" >
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Input
                  type="text"
                  className="form-control"
                  name="email"
                  value={this.state.user.email}
                  onChange={this.onChangeEmail}
                  validations={[required]}
                />
              </div>
            </Col>
            <Col sm="4" >
              <div className="form-group">
                <label htmlFor="phone">Teléfono</label>
                <Input
                  type="text"
                  className="form-control"
                  name="phone"
                  value={this.state.user.phone}
                  onChange={this.onChangePhone}
                />
              </div>
            </Col>

          </div>

          <div className="form-group text-right">

            {this.renderDeleteBtn()}

            {this.renderSaveBtn()}
            
          </div>

          {this.state.message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {this.state.message}
              </div>
            </div>
          )}
          <CheckButton
            style={{ display: "none" }}
            ref={c => {
              this.checkBtn = c;
            }}
          />
        </Form>
      </div>
    );
  }

}

export default withRouter(AgentForm);